import _ from 'lodash';
import ReactPropTypes from 'prop-types';
import { Swipe, Member, Membership } from '@swiper/core';

export const PropTypes = _.assign( {}, ReactPropTypes );
_.assign( PropTypes, {

  className : PropTypes.oneOfType( [
    PropTypes.object,
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.oneOfType( [
        PropTypes.array,
        PropTypes.object,
        PropTypes.string,
      ] ),
    ),
  ] ),

  swipe       : PropTypes.instanceOf( Swipe ),
  member      : PropTypes.instanceOf( Member ),
  membership  : PropTypes.instanceOf( Membership ),

} );
